// extracted by mini-css-extract-plugin
module.exports = {"badge":"_3QEVm","hidden":"_3B4RG","number":"_1-vcN"};